var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconArrowDropDown48Line = function SvgIconArrowDropDown48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 29.43a2.88 2.88 0 0 1-2.1-.91l-4.8-5.06a2.9 2.9 0 0 1 2.1-4.89h9.6a2.9 2.9 0 0 1 2.1 4.89l-4.79 5.06a2.911 2.911 0 0 1-2.11.91Zm-3.63-7.46L24 25.8l3.64-3.83h-7.27Z",
    fill: "current"
  })));
};
export default SvgIconArrowDropDown48Line;